import { render } from "./CargueAjustes.vue?vue&type=template&id=139140d6&scoped=true"
import script from "./CargueAjustes.vue?vue&type=script&lang=js"
export * from "./CargueAjustes.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./CargueAjustes.vue?vue&type=style&index=1&id=139140d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-139140d6"]])

export default __exports__